// extracted by mini-css-extract-plugin
module.exports = {"avatar":"LockScreen_avatar__3TaeI","googleWrapper":"LockScreen_googleWrapper__FXsDB","lockScreenBody":"LockScreen_lockScreenBody__2z9iG","unlock":"LockScreen_unlock__LKa3m"};